import React, { useState, useEffect } from 'react';
import {
  FormContainer,
  SubmitContainer,
} from '../../AdminRoutes/CreateRoutes/CreateForm.styles';
import BreadCrumbs from '../../Components/Breadcrumbs/BreadcrumbsComponent.component';
import SignupCompanySubmit from './SignupSubmit.component';
import CompanyManagerSignUp from './SignupManager.component';
import CompanyInfo from '../../Components/CompanyForm/CompanyInfo';
import AddressComponent from '../../Components/CompanyForm/Address';
import ResultModal from '../../Components/Modal/ResultModal.component';
import HelmetHelper from '../../Components/PageHelmet/HelmetHelper.component';

const CompanySignupPage = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [result, setResult] = useState('');
  const [validForm, setValidForm] = useState(false);
  const [company, setCompany] = useState({
    companyName: '',
    mainContact: '',
    secondaryContact: '',
    email: '',
    phoneOffice: '',
    phoneMobile: '',
    website: '',
    notes: '',
    secondaryEmail: '',
    secondaryPhone: '',
    industry: '',
  });
  const [billingAddress, setBillingAddress] = useState({
    street: '',
    city: '',
    province: '',
    postalCode: '',
  });
  const [user, setUser] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    password: '',
    type: 'Manager',
  });

  // Validation function
  const validateForm = () => {
    const requiredCompanyFields = ['companyName', 'mainContact', 'email'];
    const requiredBillingFields = ['street', 'city', 'province', 'postalCode'];

    const isCompanyValid = requiredCompanyFields.every(
      (field) => company[field]?.trim() !== ''
    );

    const isBillingValid = requiredBillingFields.every(
      (field) => billingAddress[field]?.trim() !== ''
    );

    setValidForm(isCompanyValid && isBillingValid);
  };

  useEffect(() => {
    validateForm();
  }, [company, billingAddress]);

  return (
    <>
      <HelmetHelper
        title="Company Sign Up"
        description="Create a company account"
      />

      <FormContainer>
        <BreadCrumbs one="Login" oneLink="/login" two="Create Company" />
        <h2>Create a company account</h2>
        <CompanyInfo company={company} setCompany={setCompany} />
        <AddressComponent
          billingAddress={billingAddress}
          setBillingAddress={setBillingAddress}
        />
        {/* Company Admin */}
        <CompanyManagerSignUp user={user} setUser={setUser} />
        <ResultModal
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          result={result}
          linkTo="/login"
          span="Login"
        />
        <SubmitContainer>
          <SignupCompanySubmit
            company={company}
            result={result}
            user={user}
            setIsOpen={setIsOpen}
            setResult={setResult}
            disabled={!validForm}
            billingAddress={billingAddress}
          />
        </SubmitContainer>
      </FormContainer>
    </>
  );
};

export default CompanySignupPage;
